export default __webpack_public_path__ + "static/media/exploreicons_desktop.592c33b2.png";